import { our, constant } from "../../../constants/pages";
import aboutimg from "../../../assets/images/pages/aboutimg.jpg";
import AnimatedPage from "../../../components/animation/AnimatedPage";
import ArrowButton from "../../../components/ui/links/ArrowButton";
import HeroSection from "../../../components/ui/Cards/Hero";
import CustomHeader from "../../../components/ui/CustomHeader/CustomHeader";

const AboutUs = () => {
  return (
    <AnimatedPage>
      <main className="w-full">
        <section className="py-12 md:py-24 lg:py-32 bg-primary-900">
          <div className="max-w-7xl flex flex-col items-center px-6 xl:px-0 pt-20 mx-auto text-center">
            <CustomHeader
              title="Coporate Setup"
              titleColor="text-white"
              description="We set up organisation and companies from incorporation, Website
                development, Register it with regulatory bodies, Train Staffs to
                achieve its corporate objectives."
              descriptionColor="text-white"
            />

            <ArrowButton
              link="/contact-us"
              text="Contact Us"
              textColor="text-primary-950"
              bgColor="bg-customyellow"
              hoverBgColor="bg-primary-500"
              iconBgColor="bg-primary-900"
              iconColor="text-customyellow"
              className="mt-8"
            />
          </div>
        </section>
        <HeroSection
          title="Who We Are"
          titleColor="text-primary-900"
          description={`
           
            <p>Corporate-Setup: Set up organisation and companies from
            incorporation, Website development, Register it with regulatory
            bodies, Train Staffs and introduce new companies to our
            database.</p>
        
            <p>We also created a web platform that enable our
            customer set up their organization and monitor it progress
            from the comfort of their homes or office, the platform also
            remind our customers when compliance document is about to be
            expire, allow them download it from their profile when it's
            ready and also allow them share documents with third party who
            required it via email.</p>
        
            <p className>Also we manage regulatory bodies
            registration and renewal of it licences for companies who have
            sign retainership with us, the also enjoy professional advice
            and representation in bidding for contract.</p>
            
            
          `}
          descriptionColor="text-primary-950"
          descriptionSpacing="space-y-3"
          buttonText="Get Started"
          buttonLink="/register"
          imageSrc={aboutimg}
          imageAlt="Hero Section"
          imagePosition="right"
          imagePositionBgColor="bg-customyellow/20"
          imageRotation="rotate-3"
          background="bg-white"
          buttonbg="bg-primary-500"
          buttonTextColor="text-primary-950"
          buttonHoverBg="bg-primary-400"
          xlSize="xl:text-lg/relaxed"
        />
        {/* Vision, mission and goals */}
        <section className="py-12 md:py-24 lg:py-32 bg-customgreen">
          <div className="max-w-7xl grid gap-8 lg:grid-cols-3 items-stretch px-6 xl:px-0 mx-auto">
            {our?.ours?.map((goals, index) => (
              <div
                key={index + 1}
                className="relative bg-white p-8 rounded-xl shadow-md h-full transition-all duration-300 hover:shadow-xl hover:translate-y-[-5px]"
              >
                <div className="absolute top-8 right-8 bg-customgreen rounded-lg p-4">
                  <goals.icon size={32} className="text-primary-700" />
                </div>

                <div className="flex flex-col h-full gap-y-4 mt-12">
                  <h3 className="text-2xl font-bold text-green-800 dark:text-green-100">
                    {goals.title}
                  </h3>
                  <p className="text-green-700 dark:text-green-200 flex-grow">
                    {goals.content}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </section>
        <section className="py-12 md:py-24 lg:py-32 bg-customyellow">
          <div className="max-w-7xl mx-auto px-6 xl:px-0">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold tracking-tight text-primary-900 sm:text-4xl mb-4">
                Why Choose Us?
              </h2>
              <p className="max-w-2xl mx-auto text-lg text-primary-700">
                At the heart of our success is our commitment to excellence and
                client satisfaction. Here's why businesses trust us with their
                most important needs:
              </p>
            </div>

            <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
              {constant.reasons.map((reason, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl shadow-md overflow-hidden flex flex-col h-full transition-all duration-300 hover:shadow-xl hover:translate-y-[-5px]"
                >
                  <div className="p-6 flex flex-col h-full">
                    <div className="flex items-center mb-4">
                      <span className="text-3xl font-bold text-primary-600 mr-3">
                        {reason.number}
                      </span>
                      <h3 className="text-xl font-semibold text-primary-900">
                        {reason.title}
                      </h3>
                    </div>
                    <p className="text-primary-700 flex-grow">
                      {reason.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
    </AnimatedPage>
  );
};

export default AboutUs;
